import { Box, SxProps, Theme } from "@mui/material";

interface CheckIconProps {
  color?: string;
  sx?: SxProps<Theme>;
}

export default function CheckIcon({ color = "#139E79", sx }: CheckIconProps) {
  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      sx={{
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        flexGrow: 0,
        minWidth: '12px',
        minHeight: '12px',
        width: '12px',
        height: '12px',
        color: color, // 设置默认颜色
        ...sx
      }}
    >
      <path 
        d="M2 6.5L5 9.5L10 3" 
        stroke="currentColor"
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
    </Box>
  );
}
